console.log('Vite ⚡️ Rails');

import '@hotwired/turbo-rails';

import 'simplebar/dist/simplebar';
import 'simplebar/dist/simplebar.css';
import 'toastify-js/src/toastify.css';

import '../controllers';

import feather from 'feather-icons';
feather.replace({ width: '1em', height: '1em' });
import '../styles/custom.css';

// Bootstrap (including Popover initialization) is loaded once, in
// theme_dependencies.js -- see the comment there for why it must not also
// be imported from this entrypoint.

// "Copy JSON" buttons on code-view blocks (app/views/sales/_json_code_block.html.haml).
// Delegated on document so it keeps working across Turbo Drive visits
// without needing re-registration, and needs no Bootstrap component.
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-copy-json]');
  if (!button) return;

  const pre = button.closest('.timeline-code-block')?.querySelector('pre');
  if (!pre) return;

  navigator.clipboard
    .writeText(pre.textContent)
    .then(() => {
      const originalLabel = button.innerHTML;
      button.innerHTML = '<i class="fa fa-check me-1"></i>Copied!';
      setTimeout(() => {
        button.innerHTML = originalLabel;
      }, 1500);
    })
    .catch((error) => {
      console.error('Failed to copy JSON to clipboard', error);
    });
});
